// extracted by mini-css-extract-plugin
module.exports = {"container":"SimpleInfoModalBody_container__KbHay","paragraphWrapper":"SimpleInfoModalBody_paragraphWrapper___X05I"};